import { CurrentDcIcon } from './CurrentDcIcon';

/**
 * author: Nick
 * id 2A23AD1A-C4F1-47B1-B482-05836097CE51
 * name current-dc
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/current-dc.svg
 * tags
 * - Battery 
 */
export const DirectCurrentIcon = CurrentDcIcon;
export default DirectCurrentIcon